export function validateSpanishId(value: string): boolean {
  const clean = value.toUpperCase().replace(/\s|-/g, "");

  const dniRegex = /^(\d{8})([A-Z])$/;
  const nieRegex = /^[XYZ]\d{7}[A-Z]$/;
  const cifRegex = /^[ABCDEFGHJNPQRSTUVW]\d{7}[A-Z0-9]$/;

  const letters = "TRWAGMYFPDXBNJZSQVHLCKE";

  // 1. VALIDAR DNI
  const dniMatch = clean.match(dniRegex);
  if (dniMatch) {
    const number = parseInt(dniMatch[1], 10);
    const expected = letters[number % 23];
    return dniMatch[2] === expected;
  }

  // 2. VALIDAR NIE
  if (nieRegex.test(clean)) {
    const map: Record<string, number> = { X: 0, Y: 1, Z: 2 };
    const prefix = clean[0];
    const numberStr = map[prefix] + clean.slice(1, 8);
    const expected = letters[parseInt(numberStr, 10) % 23];
    return clean[8] === expected;
  }

  // 3. VALIDAR CIF (Empresas)
  if (cifRegex.test(clean)) {
    return isValidCif(clean);
  }

  return false;
}

/**
 * Validador interno del algoritmo del CIF español
 */
function isValidCif(cif: string): boolean {
  const firstChar = cif[0];
  const digits = cif.slice(1, 8);
  const controlChar = cif[8];

  let sumOdd = 0;
  let sumEven = 0;

  // Algoritmo de suma ponderada
  for (let i = 0; i < digits.length; i++) {
    const digit = parseInt(digits[i], 10);

    if (i % 2 === 0) {
      // Posiciones impares en base 1 (0, 2, 4, 6 en el array indexado en 0)
      let double = digit * 2;
      if (double > 9) {
        double = Math.floor(double / 10) + (double % 10); // Suma de los dígitos (ej: 14 -> 1 + 4 = 5)
      }
      sumOdd += double;
    } else {
      // Posiciones pares en base 1 (1, 3, 5 en el array indexado en 0)
      sumEven += digit;
    }
  }

  const totalSum = sumOdd + sumEven;
  const lastDigitOfSum = totalSum % 10;
  const controlDigit = lastDigitOfSum === 0 ? 0 : 10 - lastDigitOfSum;

  // Mapeo de letras de control según el número de control obtenido
  const controlLetters = "JABCDEFGHI";
  const expectedLetter = controlLetters[controlDigit];

  // ¿Qué tipo de carácter de control se exige según la letra inicial del CIF?
  // - Tipo P: Solo letras (Sociedades locales, organismos, etc.)
  // - Tipo N: Solo números (Sociedades anónimas y de responsabilidad limitada comunes)
  // - Tipo A: Admite ambos (Casos ambiguos de cooperativas o dependencias extranjeras)
  const onlyLetters = "KPQSVW";
  const onlyNumbers = "ABEH";

  if (onlyLetters.includes(firstChar)) {
    return controlChar === expectedLetter;
  }

  if (onlyNumbers.includes(firstChar)) {
    return controlChar === controlDigit.toString();
  }

  // Si no está en los grupos anteriores (C, D, F, G, J, N, R, T), acepta tanto el número como la letra
  return controlChar === expectedLetter || controlChar === controlDigit.toString();
}

// export const validateSpanishId = (value: string) => {
//   const dniRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
//   const nieRegex = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;

//   if (!dniRegex.test(value) && !nieRegex.test(value)) return false;

//   const mapping = "TRWAGMYFPDXBNJZSQVHLCKE";
//   const str = value.toUpperCase();
  
//   // 1. Extraemos la letra final para comparar después
//   const letter = str.slice(-1);
  
//   // 2. Extraemos la parte numérica
//   let numberPart = str.slice(0, -1);

//   // 3. Reemplazamos la letra inicial SOLO si es un NIE
//   // Usamos el índice de la letra en el string para el cálculo (X=0, Y=1, Z=2)
//   numberPart = numberPart
//     .replace(/^X/, "0")
//     .replace(/^Y/, "1")
//     .replace(/^Z/, "2");

//   const number = parseInt(numberPart);

//   return mapping[number % 23] === letter;
// };